<template>
	<base-modal
		ref="$modal"
		:title="title"
		:width="width"
		:height="height"
		@on-close="emit('close')"
	>
		<div class="expand-list-modal">
			<div class="expand-list-modal__filter">
				<app-input
					:model-value="filter"
					class="expand-list-modal__filter-input"
					:placeholder="placeholder"
					show-search-button
					:debounce="150"
					@update:model-value="emit('update:filter', $event)"
				/>
			</div>

			<div
				v-if="$slots.summary"
				class="expand-list-modal__summary"
			>
				<slot name="summary" />
			</div>

			<div class="expand-list-modal__body">
				<slot />
			</div>
		</div>
	</base-modal>
</template>

<script setup lang="ts">
import { ref } from "vue";
import BaseModal from "@/components/common/modal/BaseModal.vue";
import AppInput from "@/components/ui-kit/input/AppInput.vue";

withDefaults(defineProps<{
	title?: string,
	placeholder?: string,
	filter?: string,
	width?: number | string,
	height?: number | string,
}>(), {
	title: "",
	placeholder: "Поиск",
	filter: "",
	width: 560,
	height: 640,
})

const emit = defineEmits<{
	(e: 'update:filter', value: string): void,
	(e: 'close'): void,
}>()

const $modal = ref<InstanceType<typeof BaseModal> | null>(null)

const onOpen = () => $modal.value?.onOpen()
const onClose = () => $modal.value?.onClose()

defineExpose({ onOpen, onClose })
</script>

<style scoped lang="scss">
.expand-list-modal {
	display: flex;
	flex-direction: column;
	height: 100%;
	gap: 10px;
	padding: 4px 12px 12px 12px;

	&__filter {
		width: 100%;

		&-input {
			width: 100%;

			:deep(.style-input) {
				width: 100%;
				box-sizing: border-box;
			}
		}
	}

	&__summary {
		font-size: 14px;
		line-height: 18px;
		color: #4D4D4D;
		font-weight: 500;
	}

	&__body {
		flex: 1;
		min-height: 0;
		overflow-y: auto;
		display: flex;
		flex-direction: column;
		gap: 2px;
		padding-right: 4px;
	}
}
</style>
